export default __webpack_public_path__ + "img/wosm.60c34ef5.svg";